import React from "react";
import { ContentItem } from "@/types/content";
import { ContentCard } from "./ContentCard";
import { ContentCardSkeleton } from "./ContentCardSkeleton";
import { ContentList } from "./ContentList";
import { ContentListSkeleton } from "./ContentListSkeleton";
import { Room } from "@/types/rooms";

export const ContentGrid = ({
  items,
  isLoading,
  skeletonCount = 6,
  buildHref,
  rooms,
  onAddToRoom,
  onShare,
  onDelete,
  onCardClick,
  loadingItemId,
  viewMode = 'grid',
}: {
  items: ContentItem[];
  isLoading?: boolean;
  skeletonCount?: number;
  buildHref?: (item: ContentItem) => string;
  rooms?: Room[];
  onAddToRoom?: (item: ContentItem, roomId: string) => void;
  onShare?: (item: ContentItem) => void;
  onDelete?: (item: ContentItem) => void;
  onCardClick?: (item: ContentItem) => void;
  loadingItemId?: string | null;
  viewMode?: 'grid' | 'list';
}) => {
  const href = (i: ContentItem) => {
    if (buildHref) return buildHref(i);
    return i.type === "chat" ? `/chat/${i.id}` : `/content/${i.id}`;
  };

  if (viewMode === 'list') {
    if (isLoading) {
      return <ContentListSkeleton skeletonCount={skeletonCount} />;
    }
    
    return (
      <ContentList
        items={items}
        buildHref={buildHref}
        rooms={rooms}
        onAddToRoom={onAddToRoom}
        onShare={onShare}
        onDelete={onDelete}
        onCardClick={onCardClick}
      />
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-4 xl:grid-cols-3 2xl:grid-cols-4">
      {isLoading
        ? [...Array(skeletonCount)].map((_, i) => (
            <ContentCardSkeleton key={i} />
          ))
        : items.map((item) => (
            <ContentCard
              key={item.id}
              item={item}
              href={href(item)}
              rooms={rooms}
              onAddToRoom={onAddToRoom}
              onShare={onShare}
              onDelete={onDelete}
              onCardClick={onCardClick}
              isLoading={loadingItemId === item.id}
            />
          ))}
    </div>
  );
};
